import { render, staticRenderFns } from "./VTextWithButton.vue?vue&type=template&id=0c8acd55&scoped=true"
import script from "./VTextWithButton.vue?vue&type=script&lang=js"
export * from "./VTextWithButton.vue?vue&type=script&lang=js"
import style0 from "./VTextWithButton.vue?vue&type=style&index=0&id=0c8acd55&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8acd55",
  null
  
)

export default component.exports